import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LaneFacade } from './application/lane.facade';
import { LaneRateFacade } from './application/lane-rate.facade';
import { ItemChargeFacade } from './application/item-charge.facade';
import { LaneCarrierFacade } from './application/lane-carrier.facade';
import { RadiusLaneDataService } from './infrastructure/radius-lane.data.service';

@NgModule({
    imports: [CommonModule],
    providers: [
        RadiusLaneDataService,
        LaneFacade,
        LaneRateFacade,
        ItemChargeFacade,
        LaneCarrierFacade,
    ],
})
export class SchnitzerDomainModule {}
